module.exports = __webpack_public_path__ + "img/logo.6358e4cd.png";